<template>
    <v-container>
        <h1 class="page-heading">EnergyHub Maintenance</h1>
    </v-container>
    <v-container class="maintenance container">
        <div class="maintenance__request bg-yellow-cust rounded-xl">
            <div class="maintenance__request--illustration">
                <v-img
                    class="maintenance-illustration mx-auto"
                    src="@/assets/maintenance-illustration.svg"
                />
            </div>
            <div class="maintenance__request--form">
                <v-form ref="form" v-model="valid" lazy-validation>
                    <v-text-field
                        v-model="date"
                        :rules="dateRules"
                        label="Preferred Date*"
                        type="date"
                        bg-color="white"
                        variant="outlined"
                        required
                    ></v-text-field>

                    <v-select
                        v-model="request_type"
                        :items="request_types"
                        :rules="[(v) => !!v || 'Item is required']"
                        label="Request Type*"
                        bg-color="white"
                        variant="outlined"
                        required
                    ></v-select>

                    <v-text-field
                        v-model="comments"
                        :counter="50"
                        :rules="commentsRules"
                        label="Additonal Comments"
                        bg-color="white"
                        variant="outlined"
                    ></v-text-field>

                    <SolidButton
                        text="Submit Request"
                        class="mt-2"
                        @click="validate"
                    />
                </v-form>
            </div>
        </div>
        <v-container fluid class="maintenance__history mt-3">
            <p class="title">History</p>
            <div v-if="requests.length != 0">
                <v-row class="text mt-1">
                    <v-col> <p>Reference Number</p></v-col>
                    <v-col>
                        <p>Date Initiated</p>
                    </v-col>
                    <v-col> <p>Type</p></v-col>
                    <v-col> <p>Status</p></v-col>
                </v-row>
                <v-row
                    v-for="request in requests"
                    :key="request.ref_id"
                    class="text-sm"
                >
                    <v-col>
                        <p>{{ request.ref_id }}</p></v-col
                    >
                    <v-col>
                        <p>
                            {{
                                new Date(
                                    request.date_initiated.seconds * 1000
                                ).toLocaleDateString("en-GB", {
                                    day: "numeric",
                                    month: "numeric",
                                    year: "numeric",
                                })
                            }}
                        </p>
                    </v-col>
                    <v-col>
                        <p>{{ request.request_type }}</p></v-col
                    >
                    <v-col>
                        <p>{{ request.status }}</p></v-col
                    >
                </v-row>
            </div>
            <div v-else><p class="mt-5">No records to show</p></div>
        </v-container>
    </v-container>
</template>

<script>
import SolidButton from "@/components/SolidButton.vue";
import {
    getFirestore,
    doc,
    setDoc,
    getDocs,
    Timestamp,
    query,
    collection,
    where,
    orderBy,
} from "@firebase/firestore";
import store from "@/store";

export default {
    data: () => ({
        valid: true,
        comments: "",
        commentsRules: [
            (v) => v.length <= 50 || "Comment must be less than 50 characters",
        ],
        date: null,
        dateRules: [
            (v) => !!v || "Date is required",
            (v) =>
                new Date(
                    +v.split("-")[0],
                    v.split("-")[1] - 1,
                    +v.split("-")[2]
                ) > new Date() || "Select a future date",
        ],
        request_type: null,
        request_types: ["General", "Cleaning", "Hardware Fault", "Others"],
        requests: [],
    }),
    methods: {
        async validate() {
            const { valid } = await this.$refs.form.validate();
            if (valid) this.submit_request();
        },
        submit_request() {
            const db = getFirestore();

            // Returns a random id with numeric value from 10k to 50k:
            const doc_id = "MR" + (Math.floor(Math.random() * 50000) + 10000);

            const current_request = {
                ref_id: doc_id,
                user_name: store.state.user?.name,
                user_id: store.state.user?.user_id,
                date_initiated: Timestamp.fromDate(new Date()),
                date_preferred: Timestamp.fromDate(new Date(this.date)),
                request_type: this.request_type,
                comments: this.comments,
                status: "Requested",
            };

            // Add to DB
            try {
                setDoc(
                    doc(db, "maintenance_requests", doc_id),
                    current_request
                );
                console.log("Request created and saved in DB");
                this.comments = "";
                this.date = null;
                this.request_type = null;
                this.load_requests();
            } catch (e) {
                console.error("Error adding document: ", e);
            }

            //TODO: Update list
        },
        load_requests() {
            const db = getFirestore();

            // fetch requests from DB
            const q = query(
                collection(db, "maintenance_requests"),
                where("user_id", "==", store.state.user?.user_id),
                orderBy("date_initiated", "desc")
            );
            getDocs(q)
                .then((querySnapshot) => {
                    this.requests = [];
                    querySnapshot.forEach((doc) => {
                        // doc.data() is never undefined for query doc snapshots
                        this.requests.push(doc.data());
                    });
                })
                .catch((error) => {
                    console.log("Error getting documents: ", error);
                });
        },
    },
    created() {
        this.load_requests();
    },
    components: { SolidButton },
};
</script>

<style lang="scss" scoped>
.maintenance {
    display: flex;
    flex-direction: column;
    &__request {
        display: flex;
        flex-direction: row;
        flex: 1 1 0px;

        &--illustration {
            display: flex;
            flex: 1 1 0px;
            align-items: center;
            justify-content: center;
            .maintenance-illustration {
                width: 100%;
                max-width: 400px;
            }
        }

        &--form {
            flex: 1 1 0px;
            align-items: center;

            padding: 50px 100px;
        }
    }
}
</style>
